import React from 'react'
import { useAtSize } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'
import { bool, shape, string, func } from 'prop-types'
import { css } from '@emotion/core'
import AncestorCard from './AncestorCard'

const verticalRuleCss = css`
  max-height: 175px;
  background-color: #eff0f0;
  display: inline;
`

const relationRibbonCss = css`
  background-color: #666662;
  color: white;
  padding: 4px 10px;
  border-bottom-left-radius: 3px;
  position: relative;
  font-size: 10px;
  text-transform: uppercase;
  height: fit-content;
  :after {
    content: '';
    position: absolute;
    left: 99%;
    top: 0;
    width: 0;
    height: 100%;
    border-top: 10px solid #666662;
    border-bottom: 10px solid #666662;
    border-left: 2px solid #666662;
    border-right: 4px solid transparent;
  }
`

const ribbonWrapperCss = css`
  width: 100%;
  display: flex;
  justify-content: center;
`

const wrapperWrapperCss = css`
  width: fit-content;
  position: relative;
  top: 6px;
`

export default function Couples({ disabled, side, which, leftAncestor, rightAncestor, setIsTreeShowing }) {
  const [t] = useTranslation()
  const atSize = useAtSize()

  const coupleCss = css`
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
    margin: 32px 0;
    box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.1);
    z-index: 2;
    ${disabled && 'filter: contrast(50%) brightness(130%) grayscale(100%);'}
    ${atSize({ default: 'width: calc(1px + (200vw / (3 * 1.75)))', md: 'width: 240px' })};
    ${atSize({ default: 'height: calc(100vw / (3))', md: 'height: 175px' })};

    :after {
      content: '';
      position: relative;
      z-index: -1;
      height: 127px;

      ${side &&
        (side === 'left'
          ? `
            left: 10%;
            width: 50px;
            border-bottom-left-radius: 6px;
            border-left: solid 1px #666662;  
            border-bottom: solid 1px #666662;  
          `
          : `
            right: 10%;
            width: 50px;
            border-bottom-right-radius: 6px;
            border-right: solid 1px #666662;
            border-bottom: solid 1px #666662;
          `)}
      ${!side &&
        ` 
          width: 2px;
          height: 45px;
          border-left: solid 1px #666662;
        `}
    }
  `

  return (
    <div css={coupleCss}>
      <AncestorCard disabled={disabled} personData={leftAncestor} setIsTreeShowing={setIsTreeShowing} />
      <span css={verticalRuleCss} />
      <AncestorCard disabled={disabled} personData={rightAncestor} setIsTreeShowing={setIsTreeShowing} />
      <div css={ribbonWrapperCss}>
        <div css={wrapperWrapperCss}>
          <div css={relationRibbonCss}>
            {which === 'parents'
              ? t('atf.base-tree.couples.parents', 'My parents')
              : t('atf.base-tree.couples.grandparents', 'My grandparents')}
          </div>
        </div>
      </div>
    </div>
  )
}

Couples.propTypes = {
  disabled: bool,
  which: string,
  side: string,
  leftAncestor: shape({
    personId: string,
    name: string,
    surname: string,
  }),
  rightAncestor: shape({
    personId: string,
    name: string,
    surname: string,
  }),
  setIsTreeShowing: func,
}
